const mailReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// const birthreg = /^([1-2]\d{3})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|30|31)$/;
const birthreg = /^(([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29)$/;
const emailReg =
    '^(?!(?:(?:\\x22?\\x5C[\\x00-\\x7E]\\x22?)|(?:\\x22?[^\\x5C\\x22]\\x22?)){255,})(?!(?:(?:\\x22?\\x5C[\\x00-\\x7E]\\x22?)|(?:\\x22?[^\\x5C\\x22]\\x22?)){65,}@)(?:(?:[\\x21\\x23-\\x27\\x2A\\x2B\\x2D\\x2F-\\x39\\x3D\\x3F\\x5E-\\x7E]+)|(?:\\x22(?:[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x21\\x23-\\x5B\\x5D-\\x7F]|(?:\\x5C[\\x00-\\x7F]))*\\x22))(?:\\.(?:(?:[\\x21\\x23-\\x27\\x2A\\x2B\\x2D\\x2F-\\x39\\x3D\\x3F\\x5E-\\x7E]+)|(?:\\x22(?:[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x21\\x23-\\x5B\\x5D-\\x7F]|(?:\\x5C[\\x00-\\x7F]))*\\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-+[a-z0-9]+)*\\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-+[a-z0-9]+)*)|(?:\\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\\]))';

// const pwdreg = /^(?![0-9]+$)(?![a-zA-Z]+$)(?![!#%\'\(\),\./:;<=>\?@\[\]\^_\{\}~\|]+$)(?!.*\s)[0-9a-zA-Z!#%\'\(\),\./:;<=>\?@\[\]\^_\{\}~\|]{6,16}$/i;
const pwdreg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!#%'()/*+<=>?@[\]^_{}~])[0-9a-zA-Z!#%'()/*+<=>?@[\]^_{}~]{8,16}$/;
const fullKatakanaReg = /[^\u30A1-\u30FC]+/; //全角片假名


//申请类型
const applyTypeData = [
    { id: 1, value: '個人のお申込み', isActive: false },
    { id: 2, value: '法人のお申込み', isActive: false }
]

//性别
const sexSelectData = [
    { id: 1, value: '男性', isActive: false },
    { id: 2, value: '女性', isActive: false }
]
//家长关系
const ParentalRelations = [
    { id: 1, value: '父母', isActive: false },
    { id: 2, value: '祖父母', isActive: false },
    { id: 3, value: 'その他', isActive: false }
]
// 国籍选择
const nationaltyData = [
    { id: 1, value: '日本', isActive: false },
    { id: 2, value: '米国人等', isActive: false },
    { id: 9, value: 'それ以外', isActive: false }
]
// 国籍
const nationaltyDataTwoOptions = [
    { id: 1, value: '日本', isActive: false },
    { id: 9, value: '日本以外', isActive: false }
]
//其他国籍
const OtherNationaltyData = [
    { id: 1, value: '外国PEPsに該当する（外国の政府等の要人もしくはその親族である）', isActive: true, noActive: false },
    { id: 2, value: '居住地国は日本のみである（※居住地国とは、所得税・法人税に相当する税を納める義務がある国のことをいいます。）', isActive: true, noActive: false }
]
//都道府県
const areaData = [
    { id: 1, value: '北海道', isActive: false },
    { id: 2, value: '青森県', isActive: false },
    { id: 3, value: '岩手県', isActive: false },
    { id: 4, value: '宮城県', isActive: false },
    { id: 5, value: '秋田県', isActive: false },
    { id: 6, value: '山形県', isActive: false },
    { id: 7, value: '福島県', isActive: false },
    { id: 8, value: '茨城県', isActive: false },
    { id: 9, value: '栃木県', isActive: false },
    { id: 10, value: '群馬県', isActive: false },
    { id: 11, value: '埼玉県', isActive: false },
    { id: 12, value: '千葉県', isActive: false },
    { id: 13, value: '東京都', isActive: false },
    { id: 14, value: '神奈川県', isActive: false },
    { id: 15, value: '新潟県', isActive: false },
    { id: 16, value: '富山県', isActive: false },
    { id: 17, value: '石川県', isActive: false },
    { id: 18, value: '福井県', isActive: false },
    { id: 19, value: '山梨県', isActive: false },
    { id: 20, value: '長野県', isActive: false },
    { id: 21, value: '岐阜県', isActive: false },
    { id: 22, value: '静岡県', isActive: false },
    { id: 23, value: '愛知県', isActive: false },
    { id: 24, value: '三重県', isActive: false },
    { id: 25, value: '滋賀県', isActive: false },
    { id: 26, value: '京都府', isActive: false },
    { id: 27, value: '大阪府', isActive: false },
    { id: 28, value: '兵庫県', isActive: false },
    { id: 29, value: '奈良県', isActive: false },
    { id: 30, value: '和歌山県', isActive: false },
    { id: 31, value: '鳥取県', isActive: false },
    { id: 32, value: '島根県', isActive: false },
    { id: 33, value: '岡山県', isActive: false },
    { id: 34, value: '広島県', isActive: false },
    { id: 35, value: '山口県', isActive: false },
    { id: 36, value: '徳島県', isActive: false },
    { id: 37, value: '香川県', isActive: false },
    { id: 38, value: '愛媛県', isActive: false },
    { id: 39, value: '高知県', isActive: false },
    { id: 40, value: '福岡県', isActive: false },
    { id: 41, value: '佐賀県', isActive: false },
    { id: 42, value: '長崎県', isActive: false },
    { id: 43, value: '熊本県', isActive: false },
    { id: 44, value: '大分県', isActive: false },
    { id: 45, value: '宮崎県', isActive: false },
    { id: 46, value: '鹿児島県', isActive: false },
    { id: 47, value: '沖縄県', isActive: false }
]
//口座类型
const accountTypeData = [
    { id: 1, value: '普通預金', isActive: false },
    { id: 2, value: '当座預金', isActive: false },
    { id: 3, value: '貯蓄預金', isActive: false }
]
//银行类型
const bankData = [
    { id: '0005', value: '三菱UFJ銀行', isActive: false },
    { id: '0009', value: '三井住友銀行', isActive: false },
    { id: '0001', value: 'みずほ銀行', isActive: false },
    { id: '0035', value: 'ソニー銀行', isActive: false },
    { id: '0397', value: '新生銀行', isActive: false },
    { id: '0010', value: 'りそな銀行', isActive: false },
    { id: '9900', value: 'ゆうちょ銀行', isActive: false },
    { id: '0038', value: '住信SBIネット銀行', isActive: false },
    { id: '0036', value: '楽天銀行', isActive: false },
    { id: '0033', value: 'ジャパンネット銀行', isActive: false },
    { id: '0040', value: 'イオン銀行', isActive: false },
    { id: '', value: 'その他', isActive: false },
]
//职业类型
const occuptionTypeData = [
    { id: 1, value: '上場企業の役員・社員・\n契約・派遣・パート・アルバイト', isActive: false },
    { id: 2, value: '非上場企業の役員・社員・\n契約・派遣・パート・アルバイト', isActive: false },
    // { id: 3, value: '未上場企業の役員・社員等', isActive: false },
    { id: 4, value: '公務員', isActive: false },
    { id: 5, value: '医師、医療関係', isActive: false },
    { id: 6, value: '弁護士、会計士、その他士業', isActive: false },
    { id: 7, value: '自営業、自由業', isActive: false },
    { id: 8, value: '専業主婦（主夫）、家事手伝い', isActive: false },
    { id: 9, value: '学生', isActive: false },
    { id: 10, value: '無職', isActive: false },
]
//業務
const businessData = [
    { id: 1, value: '農業/漁業', isActive: false },
    { id: 2, value: '製造業', isActive: false },
    { id: 3, value: '建設業', isActive: false },
    { id: 4, value: '情報通信事業', isActive: false },
    { id: 5, value: '運輸業', isActive: false },
    { id: 6, value: '卸売/小売業', isActive: false },
    { id: 7, value: '金融業/保険業', isActive: false },
    { id: 8, value: '不動產業', isActive: false },
    { id: 9, value: 'サービス業', isActive: false },
    { id: 10, value: '信託会社', isActive: false },
    { id: 11, value: '貸金業', isActive: false },
    { id: 12, value: '資金移動業', isActive: false },
    { id: 13, value: '仮想通貨交換業', isActive: false },
    { id: 14, value: '両替業', isActive: false },
    { id: 15, value: 'リース/リース事業', isActive: false },
    { id: 16, value: 'クレジットカード事業', isActive: false },
    { id: 17, value: '宅地雇用業', isActive: false },
    { id: 18, value: '宝石・貴金属等複製', isActive: false },
    { id: 19, value: '郵便物サービスビジネス・電話受付代行業・電話受付代行業', isActive: false },
    { id: 20, value: '弁護士・司法書士・行政書士・監査法人・税理士', isActive: false },
    { id: 21, value: 'NPO（非営利団体）', isActive: false },
    { id: 22, value: '娯楽業', isActive: false },
    { id: 23, value: 'その他', isActive: false },
]
//问题动机
const questionMotiveData = [
    { id: 1, value: '広告を見て', isActive: false },
    { id: 2, value: '友人・知人のすすめ', isActive: false },
    { id: 3, value: 'Webで検索して', isActive: false },
    { id: 4, value: 'その他', isActive: false },
]
//投资目的
const purposeData = [
    { id: 3, value: '積極的な投資による収益確保', isActive: false },
    { id: 2, value: 'バランスを取った投資による収益確保', isActive: false },
    { id: 1, value: '安定した投資による収益確保', isActive: false },
]
//年收入
const IncomeData = [
        { id: 1, value: '100万円未満', isActive: false },
        { id: 2, value: '100万円～300万円未満', isActive: false },
        { id: 3, value: '300万円～1,000万円未満', isActive: false },
        { id: 4, value: '1,000万円～3,000万円未満', isActive: false },
        { id: 5, value: '3,000万円～5,000万円未満', isActive: false },
        { id: 6, value: '5,000万円以上', isActive: false },
]
//收入种类
const revenueData = [
    { id: 1, value: '給与収入', isActive: false },
    { id: 2, value: '事業収入', isActive: false },
    { id: 3, value: '不動産収入', isActive: false },
    { id: 4, value: '利子・配当・投資収入', isActive: false },
    { id: 5, value: '世帯主等家族の収入', isActive: false },
    { id: 6, value: '年金等', isActive: false },
    { id: 7, value: '収入なし', isActive: false },
]
// 资产状况
const assetData = [
    { id: 1, value: '300万円未満', isActive: false },
    { id: 2, value: '300万円～1,000万円未満', isActive: false },
    { id: 3, value: '1,000万円～5,000万円未満', isActive: false },
    { id: 4, value: '5,000万円～1億円未満', isActive: false },
    { id: 5, value: '1億円以上', isActive: false },
]
// 资产类别
const assetTypeData = [
    { id: 1, value: '余裕資金', isActive: false },
    { id: 2, value: '投資用資金', isActive: false },
    { id: 3, value: '借入金', isActive: false },
    { id: 4, value: '生活資金', isActive: false },
]
//资产类别(新版的)
const assetTypeData2 = [
    { id: 1, value: '余裕資金', isActive: false },
]

//投资经验
const experienceData = [
    { id: 1, value: 'なし', isActive: false },
    { id: 2, value: '1年未満', isActive: false },
    { id: 3, value: '1年以上5年未満', isActive: false },
    { id: 4, value: '5年以上', isActive: false },
]
const derivativeData = [
    { id: 1, value: 'なし', isActive: false },
    { id: 2, value: '1年未満', isActive: false },
    { id: 3, value: '1年以上5年未満', isActive: false },
    { id: 4, value: '5年以上', isActive: false },
]
const experienceFundData = [
    { id: 1, value: 'なし', isActive: false },
    { id: 2, value: '1年未満', isActive: false },
    { id: 3, value: '1年以上5年未満', isActive: false },
    { id: 4, value: '5年以上', isActive: false },
]


//投资商品(根据最新改版)
const investGoodsData = [
    { id: 1, value: '現物株式', isActive: false },
    /*    { id: 2, value: 'デリバティブ取引(信用、指数／商品先物、FX、CFD、暗号資産等)', isActive: false },
        { id: 3, value: '投資信託・債券・貴金属取引', isActive: false },*/
    { id: 2, value: '投資信託、債券、貴金属', isActive: false },
    { id: 3, value: 'デリバティブ(先物取引など値動きの大きいもの)', isActive: false },
    { id: 4, value: '特定の人物やモノを応援するような投資', isActive: false },
    { id: 5, value: '社会的意義のある投資', isActive: false },
    { id: 6, value: '不動産投資', isActive: false },
    { id: 7, value: 'その他', isActive: false },
]
//内部者联系区别
const internalTiesData = [
    { id: 1, value: '役員（取締役、会計参与、監査役又は執行役）', isActive: false },
    { id: 2, value: '役員の配偶者及び同居者', isActive: false },
    { id: 3, value: '退任後 1 年以内の元役員', isActive: false },
    { id: 4, value: '従業員', isActive: false },
    { id: 5, value: '主要株主', isActive: false },
    { id: 6, value: '有価証券報告書等に記載されている大株主', isActive: false },
    { id: 7, value: '上場会社等の親会社又は子会社の役員（取締役、会計参与、監査役又は執行役）', isActive: false },
    { id: 8, value: '退任後 1 年以内の親会社又は子会社の元役員', isActive: false },
    { id: 9, value: '上場会社等の親会社又は子会社の従業員', isActive: false },
    // { id: 10, value: '役員配偶者', isActive: false },
    // { id: 11, value: '役員同居者', isActive: false },
    // { id: 12, value: '関係会社役員配偶者', isActive: false },
    // { id: 13, value: '関係会社役員同居者', isActive: false },
    // { id: 14, value: '大株主', isActive: false },
    // { id: 15, value: '主要株主', isActive: false },
]

const internalTiesData1 = [
    { id: 1, value: '役員（執行役員又は監督役員）', isActive: false },
    { id: 2, value: '役員の配偶者及び同居者', isActive: false },
    { id: 3, value: '退任後 1 年以内の元役員', isActive: false },
    { id: 4, value: '資産運用会社の役員（取締役、会計参与、監査役又は執行役）', isActive: false },
    { id: 5, value: '資産運用会社の役員の配偶者及び同居者', isActive: false },
    { id: 6, value: '資産運用会社の従業員', isActive: false },
    { id: 7, value: '退任後 1 年以内の資産運用会社の元役員', isActive: false },
    { id: 8, value: '特定関係法人の役員（取締役、会計参与、監査役又は執行役 ）', isActive: false },
    { id: 9, value: '退任後 1 年以内の特定関係法人の元役員', isActive: false },
    { id: 10, value: '特定関係法人の従業員', isActive: false },
    // { id: 11, value: '特定関係法人役員同居者', isActive: false },
    // { id: 12, value: '特定関係法人役員退職者', isActive: false },
    // { id: 13, value: '上場法人等の大株主', isActive: false }
]
//基金内部者选项
const fundInternalTiesData=[
  { id: 1, value: '役員（取締役、会計参与、監査役又は執行役）', isActive: false },
  { id: 2, value: '役員の配偶者及び同居者', isActive: false },
  { id: 3, value: '退任後 1 年以内の元役員', isActive: false },
  { id: 4, value: '従業員', isActive: false },
  { id: 5, value: '主要株主', isActive: false },
  { id: 6, value: '有価証券報告書に記載されている大株主', isActive: false },
  { id: 7, value: '親会社又は子会社の役員（取締役、会計参与、監査役又は執行役）', isActive: false },
  { id: 8, value: '退任後 1 年以内の親会社又は子会社の元役員', isActive: false },
  { id: 9, value: '親会社又は子会社の従業員', isActive: false },
]


const identityDocumentsData = [
  { id: 1, value: 'マイナンバーカード（顔写真付き）', isActive: false },
  { id: 2, value: 'マイナンバー通知カード', isActive: false },
  { id: 3, value: '住民票の写し', isActive: false },
]
//身份(国籍日本)
const identityDocumentsData_reset = [
    { id: 1, value: 'マイナンバーカード（顔写真付き）', isActive: false },
    { id: 2, value: 'マイナンバー通知カード', isActive: false },
    { id: 3, value: '住民票の写し', isActive: false },
]
//身份(国籍日本以外)
const identityDocumentsData1 = [
  { id: 1, value: 'マイナンバーカード（顔写真付き）', isActive: false },
  { id: 2, value: 'マイナンバー通知カード', isActive: false },
  { id: 3, value: '住民票の写し', isActive: false },
]

// 法人

//上場 类型
const corporateType = [
    { id: 1, value: '上場', isActive: false },
    { id: 2, value: '非上場', isActive: false }
]
// 法人区别
const legalPersonArr = [
    { id: 1, value: '株式会社', isActive: false },
    { id: 2, value: '有限会社', isActive: false },
    { id: 3, value: '合資会社', isActive: false },
]

// 事业
const businessContentArr = [
    { id: 1, value: '農林・水産業', isActive: false },
    { id: 2, value: '建設・製造業', isActive: false },
    { id: 3, value: '運輸・情報通信業', isActive: false },
    { id: 4, value: '商業(卸売・小売)', isActive: false },
    { id: 5, value: '保険・金融業', isActive: false },
    { id: 6, value: '不動産業', isActive: false },
    { id: 7, value: '飲食・宿泊業', isActive: false },
    { id: 8, value: '医療、福祉', isActive: false },
    { id: 9, value: 'サービス業', isActive: false },
    { id: 10, value: 'コンサルタント業', isActive: false },
    { id: 11, value: 'その他', isActive: false },
]
// 課税法人
const taxArr = [
    { id: 0, value: '課税法人', isActive: false },
    { id: 1, value: '非課税法人', isActive: false },
]

const capitalArr = [
    { id: 1, value: '1,000万円未満', isActive: false },
    { id: 2, value: '1,000万円～5,000万円未満', isActive: false },
    { id: 3, value: '5,000万円～1億円未満', isActive: false },
    { id: 4, value: '1億円～10億円未満', isActive: false },
    { id: 5, value: '10億円～50億円未満', isActive: false },
    { id: 6, value: '50億円～100億円未満', isActive: false },
    { id: 7, value: '100億円以上', isActive: false },
]
const corporateCapitalArr = [
    { id: 0, value: '1,000万円未満', isActive: false },
    { id: 1, value: '1,000万円～5,000万円未満', isActive: false },
    { id: 2, value: '5,000万円～1億円未満', isActive: false },
    { id: 3, value: '1億円～10億円未満', isActive: false },
    { id: 4, value: '10億円～50億円未満', isActive: false },
    { id: 5, value: '50億円～100億円未満', isActive: false },
    { id: 6, value: '100億円以上', isActive: false },
]


//公司种类
const companyTypeData = [
    { id: 1, value: '上場会社', isActive: false },
    { id: 2, value: '上場投資法人等の資産運用会社', isActive: false },
]
//申请动机
const applyMotive = [
    { id: 1, value: '広告を見て', isActive: false },
    { id: 2, value: '友人・知人のすすめ', isActive: false },
    { id: 3, value: 'Webで検索して', isActive: false },
    { id: 4, value: 'その他', isActive: false },
]
//投资目的
const InvestPurpose = [
    { id: 3, value: '積極的な投資による収益確保', isActive: false },
    { id: 2, value: 'バランスを取った投資による収益確保', isActive: false },
    { id: 1, value: '安定した投資による収益確保', isActive: false },
]

// 资金
const asstsData = [
    { id: 1, value: '100万円未満', isActive: false },
    { id: 2, value: '100万円～300万円未満', isActive: false },
    { id: 3, value: '300万円～1000万円未満', isActive: false },
    { id: 4, value: '1000万円～5000万円未満', isActive: false },
    { id: 5, value: '5000万円～1億円未満', isActive: false },
    { id: 6, value: '1億円以上', isActive: false },
]
const experienceStock = [
    { id: 1, value: 'なし', isActive: false },
    { id: 2, value: '1年未満', isActive: false },
    { id: 3, value: '1年以上5年未満', isActive: false },
    { id: 4, value: '5年以上', isActive: false },

]
// 投资商品
const InvestmentGoods = [
    { id: 1, value: '現物株式', isActive: false },
    { id: 2, value: '投資信託、債券、貴金属', isActive: false },
    { id: 3, value: 'デリバティブ（先物取引など値動きの大きいもの）', isActive: false },
    { id: 4, value: '特定の人物やモノを応援するような投資', isActive: false },
    { id: 5, value: '社会的意義のある投資', isActive: false },
    { id: 6, value: '不動産投資', isActive: false },
    { id: 7, value: 'その他', isActive: false },
]
//区分

const differentData = [
    { id: 1, value: '個人', isActive: false },
    { id: 2, value: '法人', isActive: false },
]
const relationData = [
    { id: 1, value: '25%超の議決権または配当等を受け取る権利を保有', isActive: false },
    { id: 10, value: '50％超の議決権または配当等を受け取る権利を保有', isActive: false },
    { id: 2, value: '出資•融資•取引その他の関係を通じて事業活動に支配的な影響力を保有', isActive: false },
    { id: 3, value: '法人を代表し、その業務を執行する個人', isActive: false },
]

const liveCountryData = [
    { id: 1, value: '日本', isActive: false },
    { id: 2, value: '日本以外の外国', isActive: false },
]

const reasonData = [
    { id: 1, value: '番号を付与されていない', isActive: false },
    { id: 2, value: '法令で第三者提供が禁止されている', isActive: false },
]

const documentsTypeData = [
    { id: 1, value: '運転免許証', isActive: false, noChoose: false },
    { id: 2, value: 'マイナンバーカード（顔写真付き）', isActive: false, noChoose: false },
    { id: 3, value: '各種健康保険証※', isActive: false, noChoose: false },
    { id: 4, value: '印鑑登録証明書※', isActive: false, noChoose: false },
    { id: 5, value: '各種福祉手帳※', isActive: false, noChoose: false },
    { id: 6, value: '住民票の写し※', isActive: false, noChoose: false },
    { id: 7, value: '在留カードまたは特別永住者証明書', isActive: false, noChoose: false },
]
// 最新的上传图片类型选择
const documentsTypeDataNew = [
    { id: 1, value: '運転免許証', isActive: false, noChoose: false },
    { id: 2, value: 'マイナンバーカード（顔写真付き）', isActive: false, noChoose: false },
    { id: 7, value: '在留カードまたは特別永住者証明書', isActive: false, noChoose: false },
]
//再提出的图片类型选择
const resetdocumentsTypeDataNew = [
    { id: 1, value: '運転免許証', isActive: false, noChoose: false },
    { id: 2, value: 'マイナンバーカード（顔写真付き）', isActive: false, noChoose: false },
    { id: 7, value: '在留カードまたは特別永住者証明書', isActive: false, noChoose: false },
]
// 取引，代表是否是同一人
const theSamePerson = [
    { id: 1, value: '同一', isActive: false },
    { id: 2, value: '異なる', isActive: false }
]
//メール配信フラグ
const mailInfoFlg = [
    { id: 1, value: '希望する', isActive: true },
    { id: 0, value: '希望しない', isActive: false }
]
//内部者
const insiderTypeData = [
    { id: 1, value: '該当する', isActive: false },
    { id: 0, value: '該当しない', isActive: false }
]

export default {
    mailReg,
    birthreg,
    applyTypeData,
    sexSelectData,
    ParentalRelations,
    nationaltyData,
    nationaltyDataTwoOptions,
    OtherNationaltyData,
    areaData,
    accountTypeData,
    bankData,
    occuptionTypeData,
    businessData,
    questionMotiveData,
    purposeData,
    IncomeData,
    revenueData,
    assetData,
    assetTypeData,
    assetTypeData2,
    experienceData,
    investGoodsData,
    derivativeData,
    experienceFundData,
    internalTiesData,
    internalTiesData1,
    fundInternalTiesData,
    identityDocumentsData,
    identityDocumentsData1,
    identityDocumentsData_reset,
    corporateType,
    legalPersonArr,
    businessContentArr,
    taxArr,
    capitalArr,
    emailReg,
    companyTypeData,
    applyMotive,
    InvestPurpose,
    asstsData,
    experienceStock,
    InvestmentGoods,
    differentData,
    relationData,
    liveCountryData,
    reasonData,
    documentsTypeData,
    theSamePerson,
    pwdreg,
    fullKatakanaReg,
    corporateCapitalArr,
    documentsTypeDataNew,
    resetdocumentsTypeDataNew,
    mailInfoFlg,
    insiderTypeData
}



// WEBPACK FOOTER //
// ./src/utils/common-data.js